import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Router as BaseRouter } from 'react-router'
import { httpError } from 'actions/http'
import { setUnpublished } from 'careers/actions/job-ad'
import * as analytics from 'analytics/performance'

const propTypes = {
  history: PropTypes.shape({}).isRequired,
  routes: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  currentError: PropTypes.number,
  careersState: PropTypes.shape({
    unpublished: PropTypes.bool,
  }),
}

const defaultProps = {
  currentError: null,
  careersState: undefined,
}

const mapStateToProps = state => ({
  currentError: state.global.httpError,
  careersState: state.careers,
})

class Router extends React.Component {
  constructor(props) {
    super(props)
    const { routes } = this.props
    this.routes = routes((...args) => this.onEnter(...args))
  }

  onEnter(nextState) {
    const
      { dispatch, currentError, careersState } = this.props
    const { routes, params } = nextState

    if (currentError) {
      dispatch(httpError(null))
    }

    if (careersState && careersState.unpublished) {
      dispatch(setUnpublished(false))
    }

    scrollTo(0, 0)

    const path = routes.map(({ path }) => path).join('/')
    analytics.onPageLoadEvent({
      route: path,
      routeParams: params,
    })
  }

  render() {
    const { history } = this.props
    return <BaseRouter history={history} routes={this.routes} />
  }
}

Router.propTypes = propTypes
Router.defaultProps = defaultProps

export default connect(mapStateToProps)(Router)
